import React from "react";
import { FaAward, FaIndustry } from "react-icons/fa";
import { HiOutlineCheckCircle } from "react-icons/hi2";

export default function About() {
  return (
    <section id="about" className="section">
      <div className="mx-auto max-w-7xl container-pad">
        <h2 className="section-title">Experienced Chartered Accountant Serving Clients Across India</h2>
        <p className="section-subtitle">
          We help startups, MSMEs, and working professionals stay compliant with confidence—by keeping things simple, transparent, and on time.
        </p>

        <div className="mt-10 grid gap-8 lg:grid-cols-2">
          <div className="card overflow-hidden">
            <img
              src="https://images.unsplash.com/photo-1521791055366-0d553872125f?auto=format&fit=crop&w=1600&q=80"
              alt="CA professional team discussion"
              className="h-72 w-full object-cover"
              loading="lazy"
            />
            <div className="p-6">
              <div className="font-heading text-xl text-navy-900">A human-first CA practice</div>
              <p className="mt-2 text-sm text-navy-800/75">
                We believe clients deserve clarity—what to do, what it costs, and when it will be done. No jargon, no confusion.
                Just clean execution and accountability.
              </p>

              <div className="mt-5 grid gap-3 sm:grid-cols-2">
                <div className="flex items-start gap-3">
                  <FaAward className="mt-1 text-gold-500" />
                  <div>
                    <div className="font-medium text-navy-900">10+ years experience</div>
                    <div className="text-sm text-navy-800/70">Tax, GST, ROC & audits</div>
                  </div>
                </div>
                <div className="flex items-start gap-3">
                  <FaIndustry className="mt-1 text-emeraldBrand-600" />
                  <div>
                    <div className="font-medium text-navy-900">Industries served</div>
                    <div className="text-sm text-navy-800/70">Tech, retail, services, manufacturing</div>
                  </div>
                </div>
              </div>

              <div className="mt-6 rounded-2xl bg-navy-50 p-4 border border-navy-900/5">
                <div className="flex items-start gap-3">
                  <HiOutlineCheckCircle className="text-emeraldBrand-600 mt-0.5" size={20} />
                  <p className="text-sm text-navy-800/80">
                    <span className="font-semibold text-navy-900">Trust statement:</span> Your documents and financial information are handled confidentially with proper record-keeping.
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className="space-y-5">
            <div className="card p-6">
              <div className="font-heading text-xl text-navy-900">Meet the CA</div>
              <p className="mt-2 text-sm text-navy-800/75">
                <span className="font-medium text-navy-900">CA Ankit Sharma</span> (ICAI Registered) works closely with clients to ensure timely filings and clean documentation.
                Our process is remote-friendly and WhatsApp-first—perfect for busy founders and professionals.
              </p>
              <div className="mt-5 grid grid-cols-2 gap-4">
                <div className="rounded-2xl border border-navy-900/10 bg-white p-4">
                  <div className="font-heading text-2xl text-navy-900">1000+</div>
                  <div className="text-sm text-navy-800/70">Clients served</div>
                </div>
                <div className="rounded-2xl border border-navy-900/10 bg-white p-4">
                  <div className="font-heading text-2xl text-navy-900">PAN</div>
                  <div className="text-sm text-navy-800/70">India support</div>
                </div>
              </div>
            </div>

            <div className="card p-6">
              <div className="font-heading text-xl text-navy-900">Who we typically help</div>
              <ul className="mt-3 grid gap-2 text-sm text-navy-800/80">
                <li>• Startup founders needing registration + compliances</li>
                <li>• MSMEs managing GST + accounting</li>
                <li>• Salaried individuals filing ITR with deductions</li>
                <li>• Growing companies preparing for audits/VC checks</li>
              </ul>
              <a href="#contact" className="mt-5 inline-flex font-semibold text-navy-900 hover:underline">
                Talk to us for free <span aria-hidden>→</span>
              </a>
            </div>

            <div className="card p-6 bg-gold-50 border border-gold-200/40">
              <div className="font-heading text-xl text-navy-900">Quick assurance</div>
              <p className="mt-2 text-sm text-navy-800/80">
                We keep you informed at every step. If something needs your approval, we ask before submitting—no surprises.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
